export default {
	'expense-name': 'اسم المصروف',
	'no-expenses-to-show': 'لا توجد مصاريف للعرض',
	'total-expenses': 'إجمالي المصاريف',
}
